import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'

/**
 * 參數管理 - 新增 Request Schema
 */
export const createParameterdRequestSchema = z.object({
  /** 是否啟用 */
  isEnable: z.nativeEnum(TrueFalse),
  /** 參數代碼 */
  pdCode: z.string(),
  /** 參數備註 */
  pdMemo: z.string().nullable().optional(),
  /** 參數名稱(英) */
  pdNameEn: z.string().optional(),
  /** 參數名稱(中) */
  pdNameZh: z.string(),
  /** 參數類別 */
  pmCode: z.string(),
  /** 排序 */
  sort: z.union([z.number(), z.literal('')])
})

/**
 * 參數管理 - 新增 Request
 */
export interface CreateParameterdRequest
  extends z.infer<typeof createParameterdRequestSchema> {}
